import React, { useCallback, useMemo, useState } from 'react';

const initialUser = {
  realname: 'Not Logged in',
  policies: [],
  authenticated: false
};

export const UserContext = React.createContext<any>(undefined);

const normalizeUser = (user: any) => {
  const nextUser = user || {};
  const settings = nextUser.settings || {};
  const isAuthenticated =
    nextUser?.authenticated === true ||
    Boolean(nextUser?.username || nextUser?.realname);
  const baseRecentParticipants = Array.isArray(nextUser.recentParticipants)
    ? nextUser.recentParticipants
    : settings.recentParticipants;
  const normalizedRecentParticipants = Array.isArray(baseRecentParticipants)
    ? baseRecentParticipants.slice(0, 10)
    : [];
  const nextSettings = {
    ...settings,
    recentParticipants: normalizedRecentParticipants
  };

  return {
    ...nextUser,
    authenticated: isAuthenticated,
    recentParticipants: normalizedRecentParticipants,
    settings: nextSettings
  };
};

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState({
    user: initialUser,
    isUserLoading: true
  });

  const setUser = useCallback((user: any) => setState((prev: any) => {
    const mergedUser = normalizeUser(user);
    return { ...prev, user: mergedUser, isUserLoading: false };
  }), []);

  const setIsUserLoading = useCallback((loading: boolean) => setState((prev: any) => {
    if (prev.isUserLoading === loading) {
      return prev;
    }
    return { ...prev, isUserLoading: loading };
  }), []);

  const value = useMemo(() => ({
    user: state.user,
    setUser,
    isUserLoading: state.isUserLoading,
    setIsUserLoading
  }), [state.user, state.isUserLoading, setUser, setIsUserLoading]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
